export const environment = {
  production: true,
  isTaichung: false,
  apiHost: 'https://ap.nera.gov.tw/data',
  ipApiHost: 'https://www.nera.gov.tw/data',
  editApiHost: 'https://ap.nera.gov.tw/data',
  templateEditApiHost: 'https://ap.nera.gov.tw/data',
  allowBackStageDomain: ['https://ap.nera.gov.tw'],
  recaptchaKey: '',
  commonToken: '8CC1C549-35D7-4691-9E1D-67D8EC7951B5',
  googleSiteVerification: '',
  frontsideUrl: 'https://www.nera.gov.tw',
  baseHref: '/',
};
